import AuthImage from "../../../Assets/Images/AuthBackground.png";
import optimeLogo from "../../../Assets/Images/logo.png";

import { Box, Grid } from "@material-ui/core";
import { LoaderStyle } from "./style";

const AppLoader = ({ message }) => {
  const classes = LoaderStyle();

  return (
    <Grid
      container
      alignItems="center"
      justifyContent="center"
      style={{ height: "calc(100vh - 100px)" }}
    >
      <img className={classes.optimeLogo} src={optimeLogo} alt="optime ai logo" />
      <Grid item className={classes.Wrapper}>
        <Box className={classes.MessageWrapper}>{message}</Box>
      </Grid>
      <Box className={classes.BackgroundImageWrapper}>
        <img
          style={{ width: "100%" }}
          src={AuthImage}
          alt="optime ai loading"
        />
      </Box>
    </Grid>
  );
};

export default AppLoader;
